<script setup lang="ts">
import type { NoteDragData } from "@/types/dnd.types";

defineProps<{
  data: NoteDragData;
}>();
</script>

<template>
  <span class="note-drag-ghost">{{ data.label }}</span>
</template>

<style lang="scss" scoped>
.note-drag-ghost {
  display: inline-block;
  padding: 2px 8px;
  background-color: var(--canvas-bg, #fff);
  border: 1px solid var(--canvas-border, #ccc);
  border-radius: 4px;
  font-size: small;
  white-space: nowrap;
  pointer-events: none;
}
</style>
